// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__9wn8t","side":"Dashboard_side__tsota","main":"Dashboard_main__o3uGl"};